import * as results from './slices/results/resultsThunks';
import auth from './slices/auth/authThunks';
import config from './slices/config/configThunks';
import * as search from './slices/search/searchThunks';
import * as services from './slices/services/servicesThunks';
import * as specialties from './slices/specialties/specialtiesThunks';
import * as location from './slices/location/locationThunks';
import * as chat from './slices/chat/chatThunks';
import * as rewards from './slices/rewards/rewardsThunks';
import * as promotions from './slices/promotions/promotionsThunks';
import * as cost from './slices/cost/costThunks';
import * as app from './appThunks';
import * as aiSearch from './slices/aiSearch/aiSearchThunks';

const thunks = {
  aiSearch,
  app,
  auth,
  chat,
  config,
  cost,
  results,
  search,
  services,
  location,
  rewards,
  promotions,
  specialties,
};

export default thunks;
